import { memo, useCallback, useState } from 'react';
import { SimpleImage } from '@components/common/SimpleImage';
import { UiKitButton } from '@components/common/ui-kit-button';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import { WIZARD_STEPS } from '@features/Unsubscribe/сonstants';
import styles from './KeepInMind.module.scss';
const contentData = [{
  title: 'All premium content will be locked in after your current subscription expires',
  icon: 'lock.svg'
}, {
  title: 'You will lose your progress',
  icon: 'chart.svg'
}, {
  title: 'You’ll need to re-subscribe to get access',
  icon: 'crown-star.svg'
}, {
  title: 'Cross-device sync will be off',
  icon: 'star-fall.svg'
}];
export const Item = memo(({
  title,
  icon
}: {
  title: string;
  icon: string;
}) => <div className={styles.item}>
    <div className={styles.startSection}>
      <figure className={styles.figure}>
        <SimpleImage src={icon} width={28} height={28} alt="keep" />
      </figure>
    </div>
    <h4 className={styles.itemTitle}>{title}</h4>
  </div>);
Item.displayName = 'Item';
export const KeepInMind = (props: TpWizardSteps) => {
  const [isCancelButtonDisabled, setIsCancelButtonDisabled] = useState(false);
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const {
    wizard
  } = props;
  const handleCancel = useCallback(() => {
    setIsCancelButtonDisabled(true);
    trackUnsubscribeEvent('cancel_keep_mind_chosen', {
      variant: '2-cancel'
    });
    wizard.goToStep(WIZARD_STEPS.SAD);
  }, [trackUnsubscribeEvent, wizard]);
  const handleNext = useCallback(async () => {
    trackUnsubscribeEvent('cancel_keep_mind_chosen', {
      variant: '1- keep subscription'
    });
    wizard.goToStep(WIZARD_STEPS.HAPPY);
  }, [trackUnsubscribeEvent, wizard]);
  return <Container className={styles.container} eventOnMounted="cancel_keep_mind_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="KeepInMind" data-sentry-source-file="index.tsx">
      <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">
        Keep in mind: if you cancel subscription, then
      </Title>

      <div className="double-grow">
        {contentData.map(({
        title,
        icon
      }) => <Item key={title} title={title} icon={icon} />)}
      </div>

      <ButtonGroup data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
        <UiKitButton fullWidth onClick={handleNext} className={styles.button} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Keep subscription
        </UiKitButton>
        <UiKitButton color="pure" className={styles.button} onClick={handleCancel} disabled={isCancelButtonDisabled} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Cancel
        </UiKitButton>
      </ButtonGroup>
    </Container>;
};